import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { inviteAdmin } from '../../api/lib/admins';
import { siteAdministratorsKeys } from '../../api/query-keys/administrators';
import { UserRole } from 'src/types/enum/user-role';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';

export const useInviteAdmin = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      email,
      phoneNumber,
      role,
    }: {
      email: string;
      phoneNumber: string | undefined;
      role: UserRole;
    }) => inviteAdmin(email, role, phoneNumber),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: siteAdministratorsKeys.lists(),
        });
      });

      onSuccess?.();

      toast.success(
        t('siteManagement:administrators.inviteAdminDialog.success'),
      );
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
